import type { InfoDataMap } from "~types/types";

const OPINION_BRAND_NEWSLETTER_STRING = "Bloomberg <span>Opinion</span>";
const OPINION_BRANDS = ["opinion", "view", "gadfly"];
const OPINION_BRAND = "opinion";

const BRAND_DEFAULTS = {
    eyebrowData: {
        name: null,
        url: null,
        disableEyebrow: false,
    },
    newsletterBrand: "Bloomberg",
};

const BRAND_INFO: InfoDataMap = {
    business: {
        eyebrowData: {
            name: "Business",
            url: "/",
        },
    },
    markets: {
        eyebrowData: {
            name: "Markets",
            url: "/markets",
        },
        isCobrand: true,
    },
    technology: {
        eyebrowData: {
            name: "Technology",
            url: "/technology",
        },
        newsletterBrand: "Bloomberg Technology",
        isCobrand: true,
    },
    politics: {
        eyebrowData: {
            name: "Politics",
            url: "/politics",
        },
        newsletterBrand: "Bloomberg Politics",
        isCobrand: true,
    },
    pursuits: {
        eyebrowData: {
            name: "Pursuits",
            url: "/pursuits",
        },
        newsletterBrand: "Bloomberg Pursuits",
        isCobrand: true,
    },
    opinion: {
        eyebrowData: {
            name: "Opinion",
            url: "/opinion",
        },
        newsletterBrand: OPINION_BRAND_NEWSLETTER_STRING,
        isCobrand: true,
    },
    businessweek: {
        eyebrowData: {
            name: "Businessweek",
            url: "/businessweek",
        },
        newsletterBrand: "Bloomberg Businessweek",
        isCobrand: true,
    },
    gadfly: {
        eyebrowData: {
            name: "Opinion",
            url: "/opinion",
        },
        newsletterBrand: OPINION_BRAND_NEWSLETTER_STRING,
    },
    view: {
        eyebrowData: {
            name: "Opinion",
            url: "/opinion",
        },
        newsletterBrand: OPINION_BRAND_NEWSLETTER_STRING,
    },
    wealth: {
        eyebrowData: {
            name: "Wealth",
            url: "/wealth",
        },
        isCobrand: true,
    },
    equality: {
        eyebrowData: {
            name: "Equality",
            url: "/equality",
        },
        isCobrand: true,
    },
    green: {
        eyebrowData: {
            name: "Green",
            url: "/green",
        },
        isCobrand: true,
    },
    citylab: {
        eyebrowData: {
            name: "CityLab",
            url: "/citylab",
        },
        isCobrand: true,
    },
    "new economy": {
        eyebrowData: {
            name: "New Economy",
            url: "/new-economy",
        },
    },
    newsletter: {
        eyebrowData: {
            name: "Newsletter",
            url: "/account/newsletters",
        },
    },
    cojp: {
        eyebrowData: {
            disableEyebrow: true,
        },
    },
};

export function getBrandEyebrowData({ brand = "" }) {
    const info = BRAND_INFO[brand] || {};

    return {
        ...BRAND_DEFAULTS.eyebrowData,
        ...info.eyebrowData,
    };
}

export function getNewsletterBrand({ brand = "" }) {
    const info = BRAND_INFO[brand] || {};

    return info.newsletterBrand || BRAND_DEFAULTS.newsletterBrand;
}

export const getBrandDisplayName = ({
    brand,
    franchise,
}: {
    brand: string;
    franchise: string;
}) => {
    if (OPINION_BRANDS.includes(franchise) || OPINION_BRANDS.includes(brand)) {
        return OPINION_BRAND;
    }

    return brand;
};

export const getCobrandDisplayName = ({
    brand,
    cobrand,
}: {
    brand: string;
    cobrand: string;
}) => {
    const cobrandData = BRAND_INFO[cobrand];

    if (OPINION_BRANDS.includes(brand) && !OPINION_BRANDS.includes(cobrand)) {
        return OPINION_BRAND;
    }

    if (OPINION_BRANDS.includes(brand) && OPINION_BRANDS.includes(cobrand)) {
        return "";
    }

    if (!cobrandData.isCobrand) {
        return "";
    }

    if (cobrand === brand) {
        return "";
    }

    return cobrand;
};

export function getBrandSectionFrontURL(brand = "") {
    const info = BRAND_INFO[brand] || {};

    return info.eyebrowData ? info.eyebrowData.url : "";
}
